import React from 'react'
import { Dropdown, Menu, Icon } from 'semantic-ui-react'
import {navigate , Link, useStaticQuery, graphql} from 'gatsby'
import * as styles from './styles/menu.module.css'

const NavMenu = ({location}) => {
	const MenuTemp = useStaticQuery(graphql`
		query MenuQuery {
			example {
				result {
					name
					url
					children {
						squareImageHref
						name
						url
					}
				}
			}
		}
	`)




	const MakeMenuContent = (item, index, obj) => {
		if(item.children) {
			return (
				<React.Fragment key={item.name}>
					{item.children.length > 0 ? (
						<Dropdown.Item
							//need this for the outer edge of the menu categories to also redirect
							onClick={()=>{
								navigate(`/${item.url}/`)
							}}
						>
							<Dropdown
								trigger={
									<Link to={`/${item.url}/`} className={`${styles.link} ${styles.indentProductCategory}`}>
										<Icon name="angle left" /> {item.name}
									</Link>
								}
								//need this for clicking on the parts where it it is triggering the on hover submenu pop up to also redirect
								onClick={()=>{
									navigate(`/${item.url}/`)
								}}
								simple
								icon=""
								fluid
							>
								<Dropdown.Menu
									className={styles.subMenu}
									onClick={(event) => {
										event.stopPropagation()
										/*
											added stopPropagation so that event won't
											bubble up when you clicked anywhere on the
											dropdown of a category
										*/
									}}
									direction={"left"}
								>

									{item.children.map(MakeMenuContent)}
								</Dropdown.Menu>
							</Dropdown>
						</Dropdown.Item>
					) : (
						<Dropdown.Item

							as={Link}
							to={`/${item.url}/`}
							key={item.name}

						>
							<span className={styles.indentProductCategory}>{item.name} </span>
						</Dropdown.Item>
					)}
				</React.Fragment>

			)
		}
		else {
			return (
				<Dropdown.Item

					as={Link}
					to={`/${item.url}/`}
					key={item.name}
				>
					{item.name}
				</Dropdown.Item>
			)
		}

	}



	const menu= MenuTemp.example.result


	const result = menu.map(MakeMenuContent)
	return (
		<Menu secondary>
			<Dropdown
				className={` item ${styles.mainMenu}`}
				icon="bars"
			>
			<Dropdown.Menu className={styles.menu}>
					<Dropdown.Item
						as={Link}
						to={`/`}
					>
						Home
					</Dropdown.Item>
					<Dropdown.Item
						as={Link}
						to={`/confirm/`}
					>
						Confirm Order
					</Dropdown.Item>
					<Dropdown.Item
						as={Link}
						to={`/product-list/`}
					>
						Product List
					</Dropdown.Item>
					{result}
					<Dropdown.Item
						as={Link}
						to={`/category/`}
					>
						Category List
					</Dropdown.Item>
					<Dropdown.Item
						as={Link}
						to={`/business/`}
					>
						Negosyo
					</Dropdown.Item>
					<Dropdown.Divider/>
					<Dropdown.Item
						as={Link}
						to={`/recipes/`}
					>
						Recipes and Videos
					</Dropdown.Item>
					<Dropdown.Item
						as={Link}
						to={`/stories/`}
					>
						Stories and Tips
					</Dropdown.Item>
					<Dropdown.Item
						as={Link}
						to={`/howto/`}
					>
						How-To Guides
					</Dropdown.Item>
					<Dropdown.Item
						as={Link}
						to={`/faq/`}
					>
						FAQ
					</Dropdown.Item>
				</Dropdown.Menu>
			</Dropdown>
		</Menu>
	)
}
export default NavMenu

/*
https://react.semantic-ui.com/modules/dropdown/#types-pointing
*/

